/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { Component, Input, OnDestroy } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { StockCompanyWithWeight } from '@inyova/models';

import { Subject } from 'rxjs';

import { COMPANY_SECTOR_API_KEY, MOBILE_VIEW_TRESHOLD } from '@app/app.constants';

@Component({
  selector: 'app-setup-portfolio-company-detail',
  templateUrl: './setup-portfolio-company-detail.component.html',
  styleUrls: ['./setup-portfolio-company-detail.component.scss'],
  standalone: false
})
export class SetupPortfolioCompanyDetailComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() company: StockCompanyWithWeight;
  @Input() appLocation: 'ch' | 'de';

  isLoading = true;
  limitDesc = true;
  limitExtraDesc = true;
  limitGoodDesc = true;
  limitBadDesc = true;
  limitSize = [200, 120];

  constructor(private amplitudeService: AmplitudeService) {
    this.limitSize = window.innerWidth < MOBILE_VIEW_TRESHOLD ? [200, 120] : [400, 320];
  }

  getCompanySector(company: StockCompanyWithWeight): string {
    if (!COMPANY_SECTOR_API_KEY[company.sector]) return '';
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `companyDescription.section1.sector${COMPANY_SECTOR_API_KEY[company.sector]}`;
  }

  getCompanyCoverImage(company: StockCompanyWithWeight): { backgroundImage: string } {
    return {
      backgroundImage: company.img ? `url('${company.img}')` : ''
    };
  }

  limitCopy(key: string): void {
    switch (key) {
      case 'limitDesc':
        this.limitDesc = !this.limitDesc;
        break;
      case 'limitExtraDesc':
        this.limitExtraDesc = !this.limitExtraDesc;
        break;
      case 'limitGoodDesc':
        this.limitGoodDesc = !this.limitGoodDesc;
        break;
      case 'limitBadDesc':
        this.limitBadDesc = !this.limitBadDesc;
        break;
      default:
        break;
    }
  }

  trackTooltip(name: string) {
    this.amplitudeService.trackEvent('Tooltip Info Consulted', {
      tooltip_name: name,
      screen: 'portfolio company list',
      consultation_method: 'hover'
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
